export var LegacyPersonalInfoAdaptor = function(personData) {
    var personalInfo = {};
    
    // Constructor
    if (personData) {
        personalInfo.birthDate = personData.birthDate;
        personalInfo.gender = personData.gender;
        personalInfo.taxIDS = personData.legalIDs;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return personalInfo;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyPersonalInfoAdaptor.js
// module id = 200
// module chunks = 0